import resources from '../../resources'
import methods from './methods'
import data from './data'
import mounted from './mounted'
import components from './components'
import computed from './computed'

export default {
  data,
  components,
  methods,
  computed,
  mounted,
  mixins: [resources]
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/details/resources/index.js